/*eslint-disable*/
import Api from './'

class SchoolApi {

    // GET: school/:id
    static show(id) {
        return Api.axios.get('/school/' + id)
            .then(response => response.data.school);
    }

    // GET: school
    static list(params, cancelToken = null) {
        return Api.axios.get('/school', {params, cancelToken})
            .then(response => response.data);
    }

    static exportList(params) {
        return Api.axios.get('/school/export', {params})
            .then(response => response.data);
    }

    //PUT: school/:id
    static update(id, school) {
        return Api.axios.put('/school/' + id, school)
            .then(response => response.data.school)
    }

    // POST: school
    static create(school) {
        return Api.axios.post('/school', school)
            .then(response => response.data.school);
    }

    static registerSchool(school) {
        return Api.axios.post('/register-school', school)
            .then(response => response.data.school);
    }

    // GET: school/:id/forks
    static getForks(id) {
        return Api.axios.get('/school/' + id + '/forks')
            .then(response => response.data.school);
    }

    static updateForks(id, school) {
        return Api.axios.put('/school/' + id + '/forks', school)
            .then(response => response.data.school);
    }

    static getSummary(id) {
        return Api.axios.get('/school/' + id + '/summary')
        .then(response => response.data);
    }

    static getSchoolsSummary() {
        return Api.axios.get('/schools/summary')
        .then(response => response.data);
    }

    static delete(id) {
        return Api.axios.delete('/school/' + id)
            .then(response => response.data)
    }

    static getDefaultImageUrl() {
        return api.env.API_ENDPOINT + '/storage/user-files/avatars/schools/no-photo.svg';
    }
    static getHomeworkLimits() {
        return Api.axios.get('/homework-limits')
            .then(response => response.data);
    }
}

export default SchoolApi;
